import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import {
  FormGroup, Label, Input, Button, Form,
} from 'reactstrap';
import {
  regexPattern, staticConstants, GRAPH_CONST_VALUES, NUMERIC_VALUE,
} from '../../../utils';
import NumberOfFollowers from './NumberofFollowers';
import RenderInputFiled from './RenderInputFiled';
import RenderTopCountries from './RenderTopCountries';
import RenderTopStates from './RenderTopStates';

function setFollowersValue({
  instagramFollowers = 0, facebookFollowers = 0, spotifyFollowers = 0,
  youtubeFollowers = 0, twitterFollowers = 0,
}) {
  return {
    instagram: Number(instagramFollowers),
    facebook: Number(facebookFollowers),
    spotify: Number(spotifyFollowers),
    youtube: Number(youtubeFollowers),
    twitter: Number(twitterFollowers),
  };
}

function setAudienceValue({
  age_13_17 = 0, age_18_20 = 0, age_21_24 = 0, age_25_29 = 0, age_30_34 = 0, age_35_44 = 0,
  age_45_64 = 0, age_65_plus = 0,
}) {
  return {
    age_13_17: Number(age_13_17),
    age_18_20: Number(age_18_20),
    age_21_24: Number(age_21_24),
    age_25_29: Number(age_25_29),
    age_30_34: Number(age_30_34),
    age_35_44: Number(age_35_44),
    age_45_64: Number(age_45_64),
    age_65_plus: Number(age_65_plus),
  };
}

function setTopCountriesValue({
  country1, country2, country3, countryFollowers1 = 0, countryFollowers2 = 0, countryFollowers3 = 0,
}) {
  return {
    country1,
    country2,
    country3,
    countryFollowers1: Number(countryFollowers1),
    countryFollowers2: Number(countryFollowers2),
    countryFollowers3: Number(countryFollowers3),
  };
}

function setTopStatesValue({
  state1, state2, state3, state4, state5,
  stateCountry1, stateCountry2, stateCountry3, stateCountry4, stateCountry5,
  stateFollowers1 = 0, stateFollowers2 = 0, stateFollowers3 = 0, stateFollowers4 = 0, stateFollowers5 = 0,
}) {
  return {
    stateCountry1,
    state1,
    stateCountry2,
    state2,
    stateCountry3,
    state3,
    stateCountry4,
    state4,
    stateCountry5,
    state5,
    stateFollowers1: Number(stateFollowers1),
    stateFollowers2: Number(stateFollowers2),
    stateFollowers3: Number(stateFollowers3),
    stateFollowers4: Number(stateFollowers4),
    stateFollowers5: Number(stateFollowers5),
  };
}

function createApiObj(data) {
  const {
    authenticFollowers = 0, male = 0, female = 0, american = 0, asian = 0, white = 0, hispanic = 0,
    instagramRate = 0, facebookRate = 0, twitterRate = 0,
  } = data;
  const demoGraphObj = {
    authenticFollowers: Number(authenticFollowers),
    audienceGender: {
      male: Number(male),
      female: Number(female),
    },
    audienceEthnicity: {
      american: Number(american),
      asian: Number(asian),
      white: Number(white),
      hispanic: Number(hispanic),
    },
    engagementRate: {
      instagramRate: Number(instagramRate),
      facebookRate: Number(facebookRate),
      twitterRate: Number(twitterRate),
    },
  };
  demoGraphObj.followers = setFollowersValue(data);
  demoGraphObj.audienceAge = setAudienceValue(data);
  demoGraphObj.topCountry = setTopCountriesValue(data);
  demoGraphObj.topState = setTopStatesValue(data);

  return demoGraphObj;
}
function AddDemoGraphics(props) {
  const {
    graphData, submitCallBack, isShowPreviousPage, cancelGraph,
    updateIsEditDemoGraph,
  } = props;
  const [form, setState] = useState({
    country1: null,
    country2: null,
    country3: null,
    stateCountry1: null,
    stateCountry2: null,
    stateCountry3: null,
    stateCountry4: null,
    stateCountry5: null,
    state1: null,
    state2: null,
    state3: null,
    state4: null,
    state5: null,
  });
  const {
    register, errors, setValue, handleSubmit, watch, triggerValidation, getValues,
  } = useForm({ mode: 'onBlur', nativeValidation: false });

  useEffect(() => {
    register({ name: 'country1' });
    register({ name: 'country2' });
    register({ name: 'country3' });
    register({ name: 'stateCountry1' });
    register({ name: 'stateCountry2' });
    register({ name: 'stateCountry3' });
    register({ name: 'stateCountry4' });
    register({ name: 'stateCountry5' });
    register({ name: 'state1' });
    register({ name: 'state2' });
    register({ name: 'state3' });
    register({ name: 'state4' });
    register({ name: 'state5' });
    if (graphData) {
      if (!graphData.isDefaultData) {
        delete graphData.topCountry.country1.__typename;
        delete graphData.topCountry.country2.__typename;
        delete graphData.topCountry.country3.__typename;
        delete graphData.topState.stateCountry1.__typename;
        delete graphData.topState.stateCountry2.__typename;
        delete graphData.topState.stateCountry3.__typename;
        delete graphData.topState.stateCountry4.__typename;
        delete graphData.topState.stateCountry5.__typename;
        delete graphData.topState.state1.__typename;
        delete graphData.topState.state2.__typename;
        delete graphData.topState.state3.__typename;
        delete graphData.topState.state4.__typename;
        delete graphData.topState.state5.__typename;
      }
      const preFilledData = {
        country1: graphData.topCountry.country1,
        country2: graphData.topCountry.country2,
        country3: graphData.topCountry.country3,
        stateCountry1: graphData.topState.stateCountry1,
        stateCountry2: graphData.topState.stateCountry2,
        stateCountry3: graphData.topState.stateCountry3,
        stateCountry4: graphData.topState.stateCountry4,
        stateCountry5: graphData.topState.stateCountry5,
        state1: graphData.topState.state1,
        state2: graphData.topState.state2,
        state3: graphData.topState.state3,
        state4: graphData.topState.state4,
        state5: graphData.topState.state5,
      };
      setValue([
        { facebookFollowers: graphData.followers.facebook },
        { instagramFollowers: graphData.followers.instagram },
        { spotifyFollowers: graphData.followers.spotify },
        { youtubeFollowers: graphData.followers.youtube },
        { twitterFollowers: graphData.followers.twitter },
        { authenticFollowers: graphData.authenticFollowers },
        { age_13_17: graphData.audienceAge.age_13_17 },
        { age_18_20: graphData.audienceAge.age_18_20 },
        { age_21_24: graphData.audienceAge.age_21_24 },
        { age_25_29: graphData.audienceAge.age_25_29 },
        { age_30_34: graphData.audienceAge.age_30_34 },
        { age_35_44: graphData.audienceAge.age_35_44 },
        { age_45_64: graphData.audienceAge.age_45_64 },
        { age_65_plus: graphData.audienceAge.age_65_plus },
        { male: graphData.audienceGender.male },
        { female: graphData.audienceGender.female },
        { american: graphData.audienceEthnicity.american },
        { asian: graphData.audienceEthnicity.asian },
        { white: graphData.audienceEthnicity.white },
        { hispanic: graphData.audienceEthnicity.hispanic },
        { facebookRate: graphData.engagementRate.facebookRate },
        { instagramRate: graphData.engagementRate.instagramRate },
        { twitterRate: graphData.engagementRate.twitterRate },
        { country1: graphData.topCountry.country1 },
        { country2: graphData.topCountry.country2 },
        { country3: graphData.topCountry.country3 },
        { countryFollowers1: graphData.topCountry.countryFollowers1 },
        { countryFollowers2: graphData.topCountry.countryFollowers2 },
        { countryFollowers3: graphData.topCountry.countryFollowers3 },
        { stateCountry1: graphData.topState.stateCountry1 },
        { stateCountry2: graphData.topState.stateCountry2 },
        { stateCountry3: graphData.topState.stateCountry3 },
        { stateCountry4: graphData.topState.stateCountry4 },
        { stateCountry5: graphData.topState.stateCountry5 },
        { state1: graphData.topState.state1 },
        { state2: graphData.topState.state2 },
        { state3: graphData.topState.state3 },
        { state4: graphData.topState.state4 },
        { state5: graphData.topState.state5 },
        { stateFollowers1: graphData.topState.stateFollowers1 },
        { stateFollowers2: graphData.topState.stateFollowers2 },
        { stateFollowers3: graphData.topState.stateFollowers3 },
        { stateFollowers4: graphData.topState.stateFollowers4 },
        { stateFollowers5: graphData.topState.stateFollowers5 },
      ]);
      setState({
        ...form,
        ...preFilledData,
      });
    }
  }, [graphData]);

  const handleCountryChange = (selectedOption, key, stateValue) => {
    setValue(key, selectedOption);
    stateValue && setValue(stateValue, null);
    setState({
      ...form,
      [key]: selectedOption,
      [stateValue]: null,
    });
  };

  const handleStateChange = (selectedOption, key) => {
    setValue(key, selectedOption);
    setState({
      ...form,
      [key]: selectedOption,
    });
  };

  const onSubmit = ((data) => submitCallBack(createApiObj(data)));

  const handleCancelGraph = () => {
    cancelGraph(false);
    updateIsEditDemoGraph(false);
  };

  return (
    <div className="demographic-form-wrapper">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <h2>Artist Demographics</h2>
        <div className="form-section input-col-5">
          <h3>Number of Followers</h3>
          <NumberOfFollowers
            errors={errors}
            register={register}
            formData={form}
          />
        </div>
        <div className="form-section input-col-5">
          <RenderInputFiled
            errors={errors}
            register={register}
            formData={form}
            type={GRAPH_CONST_VALUES.AUTHENTIC}
          />
        </div>
        <div className="form-section input-col-8">
          <h3>Audience Age</h3>
          <RenderInputFiled
            errors={errors}
            register={register}
            formData={form}
            type={GRAPH_CONST_VALUES.AUDIENCE}
          />
        </div>
        <div className="form-section input-col-3">
          <h3>Top Country</h3>
          <RenderTopCountries
            errors={errors}
            register={register}
            formData={form}
            handleCountryChange={handleCountryChange}
          />
        </div>
        <div className="form-section input-col-2">
          <h3>Top State</h3>
          <RenderTopStates
            errors={errors}
            register={register}
            formData={form}
            handleCountryChange={handleCountryChange}
            handleStateChange={handleStateChange}
          />
        </div>
        <div className="form-section input-col-6">
          <h3>Audience Gender</h3>
          <FormGroup className={`input-field field-group ${errors.male && `${staticConstants.ERROR_CLASS.FORM_ERROR}`}`}>
            <Label
              for="Male"
            >
              Male
            </Label>
            <Input
              type="text"
              name="male"
              data-label="Male"
              value={form.male}
              onBlur={() => { getValues('female') && triggerValidation('female'); }}
              placeholder="%"
              innerRef={register({
                pattern: {
                  value: regexPattern.NUMBER_ZERO_TO_HUNDRED_DECIMAL,
                },
                validate: (value) => {
                  const limit = NUMERIC_VALUE.HUNDRED - watch('female');
                  return Number(value) <= Number(limit);
                },

              })}
            />
          </FormGroup>
          <FormGroup className={`input-field field-group ${errors.female && `${staticConstants.ERROR_CLASS.FORM_ERROR}`}`}>
            <Label
              for="Female"
            >
              Female
            </Label>
            <Input
              type="text"
              name="female"
              data-label="Female"
              value={form.female}
              placeholder="%"
              onBlur={() => { getValues('male') && triggerValidation('male'); }}
              innerRef={register({
                pattern: {
                  value: regexPattern.NUMBER_ZERO_TO_HUNDRED_DECIMAL,
                },
                validate: (value) => {
                  const limit = NUMERIC_VALUE.HUNDRED - watch('male');
                  return Number(value) <= Number(limit);
                },
              })}
            />
          </FormGroup>
        </div>
        <div className="form-section input-col-5">
          <h3>Audience Ethnicity</h3>
          <RenderInputFiled
            errors={errors}
            register={register}
            formData={form}
            type={GRAPH_CONST_VALUES.ETHNICITY}
          />
        </div>
        <div className="form-section input-col-7">
          <h3>Engagement Rate</h3>
          <RenderInputFiled
            errors={errors}
            register={register}
            formData={form}
            type={GRAPH_CONST_VALUES.ENGAGEMENT}
          />
        </div>
        <div className="modal-btn-group">
          <span onClick={() => { handleCancelGraph(); }}>Cancel</span>
          <Button
            color="publish"
            type="submit"
          >
            {isShowPreviousPage ? 'Update' : 'Save'}
          </Button>
        </div>
      </Form>
    </div>
  );
}

AddDemoGraphics.propTypes = {
  graphData: PropTypes.object.isRequired,
  submitCallBack: PropTypes.func.isRequired,
  isShowPreviousPage: PropTypes.bool.isRequired,
  cancelGraph: PropTypes.func.isRequired,
  updateIsEditDemoGraph: PropTypes.func.isRequired,
};

export default AddDemoGraphics;
